module.exports = __webpack_public_path__ + "img/ice-full.3d9b7c23.png";